<template>
    <div class="page">
        <div class="form-box">
            <p class="f-fc1 f-fs16 f-fwb mb-50">请输入录播主机机身号</p>
            <van-field input-align="center" v-model="formData.deviceNo" placeholder="请注意区分字母大小写" />
            <van-button class="btn" type="primary" @click="bindMobile">查询</van-button>
        </div>
        <div class="result-box" v-if="isDeviceWarranty">
            <div class="title">查询结果</div>
            <div class="data-box" v-if="!isEmpty(deviceWarranty)">
                <div data-flex="cross:center">
                    <p class="f-fc1 f-fwb" data-flex-box="1">销售订单编号：</p>
                    <span class="f-fc12 f-fwb">{{ deviceWarranty.orderNo }}</span>
                </div>
                <div data-flex="cross:center">
                    <p class="f-fc1 f-fwb" data-flex-box="1">机身号码：</p>
                    <span class="f-fc12 f-fwb">{{ deviceWarranty.deviceNo }}</span>
                </div>
                <div data-flex="cross:center">
                    <p class="f-fc1 f-fwb" data-flex-box="1">出厂日期：</p>
                    <span class="f-fc12 f-fwb">{{ deviceWarranty.exFactoryDate }}</span>
                </div>
                <div data-flex="cross:center">
                    <p class="f-fc1 f-fwb" data-flex-box="1">出保日期：</p>
                    <span class="f-fc12 f-fwb">{{ deviceWarranty.warranty }}</span>
                </div>
                <div data-flex="cross:center">
                    <p class="f-fc1 f-fwb" data-flex-box="1">质保期：</p>
                    <span class="f-fc12 f-fwb">{{ deviceWarranty.expirationDate }}</span>
                </div>
            </div>
            <div class="no-data" data-flex="dir:top cross:center main:center" v-else>
                <img src="../../assets/images/noData.png" />
                <p class="mt-0 f-fc12">Sorry，暂时未找到该机身号的任何信息~</p>
            </div>
        </div>


    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, NumberKeyboard, Field } from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
    mixins: [mix1],
    components: {
        MgPopup, Button, NumberKeyboard,
        [Field.name]: Field,
        [Button.name]: Button,
    },
    data() {
        return {
            isCountdowning: false,
            isDeviceWarranty: false,
            formData: {
                deviceNo: ''
            },
            deviceWarranty: {}
        }
    },
    methods: {
        async bindMobile() {
            let formData = this.formData
            const promise = this.apiGet('device.warranty', formData)

            if (this.isEmpty(formData.deviceNo)) {
                uiAlert('请填写主机机身号')
                return
            }
            uiShowLoading()
            await delayAsync(500)

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }

            this.deviceWarranty = apiResult.obj
            this.isDeviceWarranty = true
        },

    },
    mounted() {

    },
    created() {
        let query = this.$route.query
    }
}
</script>

<style lang="less" scoped>
.page {
    .form-box {
        margin-top: 20px;
        padding: 100px 80px;
        box-sizing: border-box;
        background: #fff;

        text-align: center;

        .van-cell {
            padding: 20px;
            border: solid 1px #BFBFBF;
            border-radius: 15px;


        }
    }

    .result-box {
        margin-top: 20px;
        padding: 30px 35px 0;
        box-sizing: border-box;
        background: #fff;

        .title {
            padding-bottom: 30px;
            font-size: 16px;
            font-weight: bold;
            color: #000;
            border-bottom: solid 1px #f1f1f1;
        }

        .data-box {
            div {
                padding: 24px 0;
                box-sizing: border-box;
                border-bottom: solid 1px #f1f1f1;

                p {
                    font-size: 14px;
                }

                span {
                    font-size: 14px;
                    color: #B5B5B5;
                    font-weight: normal;
                }
            }
        }
    }

    .no-data {
        height: 600px;

        img {
            width: 422px;
            height: 400px;
        }
    }

    .btn {
        width: 403px;
        height: 88px;
        border-radius: 500px;
        margin-top: 50px;
        background: #205CFF;
        border: solid 1px #205CFF;
    }
}
</style>